import { render, staticRenderFns } from "./RobTable.vue?vue&type=template&id=7c2a5ffa"
import script from "./RobTable.vue?vue&type=script&lang=js"
export * from "./RobTable.vue?vue&type=script&lang=js"
import style0 from "./RobTable.vue?vue&type=style&index=0&id=7c2a5ffa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports